import React, { useContext, useEffect } from 'react'
import { s3Static } from '../../../../utils/constants'
import Image from 'next/image'
import { RequestContext } from '../../../../context/RequestContext'
import { openModal } from '../../../../service/modal-service'
import { MdKeyboardArrowRight, MdKeyboardDoubleArrowRight } from 'react-icons/md'
import { airconDeals } from 'utils/airconDeals'
import { HiSparkles } from 'react-icons/hi2'
import { FaAngleRight } from 'react-icons/fa'
import { AirconScrollSection } from './AirconScrollSection'

// The values AirconDealItem filters on (selectedService). Every page that offers
// a deals filter builds its <select> from this list: the locality pages used to
// send "chemical-overhaul", "gas-refill", "general-service" etc., which matched
// none of the checks below, so every choice except "All Services" showed nothing.
// Chemical wash and overhaul share one filter, as do the two compressor deals.
export const AIRCON_DEAL_FILTERS = [
    { value: 'all', label: 'All Services' },
    { value: 'general', label: 'General Service' },
    { value: 'chemical', label: 'Chemical Wash & Overhaul' },
    { value: 'refrigerant', label: 'Gas Refill' },
    { value: 'repair', label: 'Aircon Repair' },
    { value: 'compressor', label: 'Compressor Cleaning' },
]

export const AirconDealItem = (props) => {

    const setIsShowAirconItemSelection = props.setIsShowAirconItemSelection
    const showJobScope = props.showJobScope
    const setRequestForm = props.setRequestForm
    const setIsQuickBook = props.setIsQuickBook;
    const selectedService = props.selectedService
    const { setRequestCriteria, setRequestDescription } = useContext(RequestContext);

    // "More options" / "other issues" open the AirconItemSelection sheet, not
    // the question wizard. The sheet sets isCustomBook itself on Continue.
    const openRequestModal = () => {
        setIsQuickBook(false)
        setIsShowAirconItemSelection(true)
    }

    const confirmBook = (criteria) => {
        setRequestCriteria(criteria)
        setRequestDescription('Aircon Service')
        setIsQuickBook(true)
        // A quick book is not a custom (picker) booking, whatever came before
        props.setIsCustomBook?.(false)
        // setRequestForm(true)
        openModal(setRequestForm)
    }
    
    const quickBook= (unitCount, serviceType) => {
        let criteria = [
            {1: 'General servicing for cleaning', criteria: 'Type of service - General servicing for cleaning'},
            {2: unitCount.toString(), criteria: "Number of aircon units to be serviced - " + unitCount},
            {21: 'Only once', criteria: 'Frequency of service - Only once'},
            {24: 'Wall', criteria: 'Mount type - Wall'}
        ]
        
        if(serviceType === "chemicalWash"){
            criteria = 
                [
                    {1: 'Chemical cleaning', criteria: 'Type of service - Chemical cleaning'},
                    {2: unitCount.toString(), criteria: "Number of aircon units to be serviced - " + unitCount},
                    {3: 'Basic chemical wash (partial dismantling may be needed)', criteria: 'Basic chemical wash (partial dismantling may be needed)'},
                    {21: 'Only once', criteria: 'Frequency of service - Only once'},
                    {24: 'Wall', criteria: 'Mount type - Wall'}
                ]
        } 

        if(serviceType === "chemicalOverhaul"){
            criteria = 
                [
                    {1: 'Chemical cleaning', criteria: 'Type of service - Chemical cleaning'},
                    {2: unitCount.toString(), criteria: "Number of aircon units to be serviced - " + unitCount},
                    {3: 'Chemical overhaul (deeper cleaning by dismantling)', criteria: 'Chemical overhaul (deeper cleaning by dismantling)'},
                    {21: 'Only once', criteria: 'Frequency of service - Only once'},
                    {24: 'Wall', criteria: 'Mount type - Wall'}
                ]
        }

        if(serviceType === "gasRefill"){
            criteria = 
                [
                    {1: 'Gas top up only', criteria: 'Type of service - Gas top up only'},
                    {27: unitCount.toString(), criteria: "Number of condensers for gas refill - " + unitCount},
                    {22: 'Full tank refill', criteria: 'Quantity of gas for refill - Full tank refill'},
                    {26: 'Not sure', criteria: 'Gas type - Not sure'}
                ]
        }

        if(serviceType === "compressorCleaning"){
            criteria = 
                [
                    {1: 'Condenser cleaning', criteria: 'Type of service - Condenser cleaning'},
                    {5: unitCount.toString(), criteria: "Total condenser units - " + unitCount},
                    {51: 'Normal cleaning', criteria: 'Type of condenser cleaning - Normal cleaning'},
                    {25: 'No', criteria: 'Gas refill needed - No'}
                ]
        }

        if(serviceType === "compressorChemicalCleaning"){
            criteria = 
                [
                    {1: 'Condenser cleaning', criteria: 'Type of service - Condenser cleaning'},
                    {5: unitCount.toString(), criteria: "Total condenser units - " + unitCount},
                    {51: 'Chemical cleaning', criteria: 'Type of condenser cleaning - Chemical cleaning'},
                    {25: 'No', criteria: 'Gas refill needed - No'}
                ]
        }

        confirmBook(criteria)
    }

    const repairBook = (problemStatement) => {
        const criteria = 
        [
            {"1":"Aircon repair (water leaking, not cooling, no power etc.)","criteria":"Type of service - Aircon repair"},
            {"4":problemStatement,"criteria":"Problem - " + problemStatement}
        ]
        confirmBook(criteria)
    }

    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setIsQuickBook(false)
    }, [setIsQuickBook, setRequestCriteria, setRequestDescription])

  return (
    <>  
        {(selectedService === "repair" || selectedService === "all") &&
            <section className='space-y-4 py-2'>            
                <header className='space-y-2'>
                    <div className='flex items-center space-x-2'>
                        <h3 className='sm:text-lg font-bold'>                
                            Book Aircon Repair
                        </h3>
                        <button type="button" className="text-orange-600 text-sm flex items-center gap-1 hover:underline" onClick={() => showJobScope("repair")} aria-label="View service details">
                            <MdKeyboardDoubleArrowRight className='text-xl sm:text-2xl animate-pulse'/>
                            <span>Service Details&nbsp;</span>
                        </button>
                    </div>
                </header>
                {/* Text-only repair cards: the photos sat behind a 40% black
                    overlay purely to make the label readable, so they cost
                    height and bandwidth without conveying anything. */}
                <div className='grid grid-cols-3 gap-3'>
                    <button type="button" className="px-2 py-4 text-center w-full bg-white shadow-sm border border-gray-200 hover:border-orange-200 hover:shadow-md active:scale-[0.98] transition-all rounded-2xl"
                     onClick={() => repairBook("aircon leaking water")} aria-label='Book aircon leaking water repair'>
                        <span className="text-xl">💧</span>
                        <span className="block text-xs sm:text-sm font-semibold text-gray-800 mt-1.5 leading-tight">
                            Aircon Leaking Water
                        </span>
                    </button>
                    <button type="button" className="px-2 py-4 text-center w-full bg-white shadow-sm border border-gray-200 hover:border-orange-200 hover:shadow-md active:scale-[0.98] transition-all rounded-2xl"
                     onClick={() => repairBook("aircon not cold")} aria-label='Book aircon not cold repair'>
                        <span className="text-xl">🌡️</span>
                        <span className="block text-xs sm:text-sm font-semibold text-gray-800 mt-1.5 leading-tight">
                            Aircon Not Cold
                        </span>
                    </button>
                    <button type="button" className="px-2 py-4 text-center w-full bg-white shadow-sm border border-gray-200 hover:border-orange-200 hover:shadow-md active:scale-[0.98] transition-all rounded-2xl"
                        onClick={() => openRequestModal()} aria-label='Book aircon repair for other issues'>
                        <span className="text-xl">🛠️</span>
                        <span className="block text-xs sm:text-sm font-semibold text-gray-800 mt-1.5 leading-tight">
                            More Options
                        </span>
                    </button>
                </div>
            </section>
        }
        {(selectedService === "general" || selectedService === "all") &&
            <section className='space-y-4 py-2'>
                <header className='space-y-2'>
                    <div className='flex items-center space-x-2'>
                        <h3 className='font-bold sm:text-lg'>                
                            General Service
                        </h3>
                        <button type="button" className='text-orange-600 text-sm flex items-center gap-1 hover:underline' onClick={() => showJobScope("general")} aria-label="View service details">
                            <MdKeyboardDoubleArrowRight className='text-xl sm:text-2xl animate-pulse'/>
                            <span>Service Details&nbsp;</span>
                        </button>
                    </div>
                </header>
                <div className='grid grid-cols-3 md:grid-cols-5 gap-3 pb-2 h-full items-center'>
                    {[...airconDeals].filter(d => d.serviceType === "general").splice(0,5).map((listing, i) =>
                        <button type='button' key={i} className='rounded-2xl shadow-lg border border-gray-100 hover:scale-102 hover:-translate-y-1 transition-all bg-white w-full overflow-hidden' 
                            onClick={() => quickBook(listing.unit, listing.serviceType)}
                            role="link"
                            aria-label={`Book ${listing.unit} unit aircon general service`} 
                        >                                    
                            <div className="p-3 text-center">
                                <div className="bg-linear-to-r from-indigo-500 to-purple-500 text-white text-sm sm:text-lg font-bold px-2 py-1 rounded-full shadow whitespace-nowrap inline-block">
                                    ${listing.cost}
                                </div>
                                <div className="mt-2">
                                <h4 className="font-semibold text-gray-800">{listing.unit} AC</h4>
                                <p className="text-sm text-gray-500">{listing.unitType} mount</p>
                                {listing.originalCost > 0 && (
                                    <div className="text-xs text-gray-400 line-through">${listing.originalCost}</div>
                                )}

                                </div>
                            </div>
                        </button>
                    )}
                    <button
                        type="button"
                        onClick={() => openRequestModal()}
                        className="md:hidden rounded-2xl shadow-lg border border-gray-100 hover:scale-102 hover:-translate-y-1 transition-all bg-white w-full overflow-hidden h-full"
                    >
                        <div className="p-3 text-center flex flex-col items-center justify-center h-full">
                            <HiSparkles className="text-2xl text-orange-500" />
                            <div className="font-bold text-gray-800 text-sm mt-2">Annual Package</div>
                        </div>
                    </button>
                </div>                       
                {/* More Options */}
                <button
                    type="button"
                    onClick={() => openRequestModal()}
                    className="hidden md:block w-full relative overflow-hidden bg-linear-to-br from-gray-700 to-gray-900 text-white rounded-2xl shadow-lg p-4"
                >
                    <div className="absolute top-0 right-0 w-20 h-20 bg-white/5 rounded-full -mr-10 -mt-10" />
                    <div className="flex items-center justify-center gap-3">
                        <HiSparkles className="text-2xl text-gray-300" />
                        <div className="text-left">
                            <div className="font-semibold">Annual Packages</div>
                            <p className="text-xs opacity-70">Custom General Service</p>
                        </div>
                        <FaAngleRight className="text-gray-400" />
                    </div>
                </button>   
            </section>
        }
        {(selectedService === "chemical" || selectedService === "all") && (
            <AirconScrollSection
                title="Chemical Overhaul"
                jobScopeKey="chemicalOverhaul"
                listings={[...airconDeals].filter(d => d.serviceType === "chemicalOverhaul").slice(0, 5)}
                quickBook={quickBook}
                showJobScope={showJobScope}
                openRequestModal={openRequestModal}
                moreOptionsLabel="Custom Chemical Overhaul"
            />
        )}
        {(selectedService === "chemical" || selectedService === "all") && (
            <AirconScrollSection
                title="Chemical Wash"
                jobScopeKey="chemicalWash"
                listings={[...airconDeals].filter(d => d.serviceType === "chemicalWash").slice(0, 5)}
                quickBook={quickBook}
                showJobScope={showJobScope}
                openRequestModal={openRequestModal}
                moreOptionsLabel="Custom Chemical Wash"
            />
        )}
        {(selectedService === "refrigerant" || selectedService === "all") &&
            <section className='space-y-4 py-2'>
                <header className='flex items-center space-x-2'>
                    <h3 className='font-bold sm:text-lg'>               
                        Gas Refill
                    </h3>
                    <button type="button" className="text-orange-600 text-sm flex items-center gap-1 hover:underline" onClick={() => showJobScope("gasRefill")} aria-label="View service details">
                        <MdKeyboardDoubleArrowRight className='text-xl sm:text-2xl animate-pulse'/>
                        <span>Service Details&nbsp;</span>
                    </button>
                </header>
                <div className='grid grid-cols-3 gap-3 pb-2 h-full items-center'>
                    {[...airconDeals].filter(d => d.serviceType === "gasRefill").slice(0,3).map((listing, i) =>
                        <button type="button" key={i} className='rounded-2xl shadow-lg border border-gray-100 hover:scale-102 hover:-translate-y-1 transition-all bg-white w-full overflow-hidden'
                            onClick={() => quickBook(listing.unit, listing.serviceType)}
                            role="link"
                            aria-label={`Book ${listing.unit} unit compressor gas refill`} 
                        >     
                            <div className="p-3 text-center">
                                <div className="bg-linear-to-r from-indigo-500 to-purple-500 text-white text-sm sm:text-lg font-bold px-2 py-1 rounded-full shadow whitespace-nowrap inline-block">
                                    ${listing.cost}
                                </div>
                                <div className="mt-2 space-y-1">
                                <h4 className="font-semibold text-gray-800">{listing.unit} Units</h4>
                                <p className="text-sm text-gray-500">Full Tank Refill</p>
                                {listing.originalCost > 0 && (
                                    <div className="text-xs text-gray-400 line-through">${listing.originalCost}</div>
                                )}
                                </div>
                            </div>
                        </button>
                    )}
                </div>
            </section>
        }
        {(selectedService === "compressor" || selectedService === "all") &&
            <section className='space-y-4 py-2'>
                <header className='flex items-center space-x-2'>
                    <h3 className='font-bold sm:text-lg'>                
                        Compressor Cleaning
                    </h3>
                    <button type="button" className="text-orange-600 text-sm flex items-center gap-1 hover:underline" onClick={() => showJobScope("compressorCleaning")} aria-label="View service details">
                        <MdKeyboardDoubleArrowRight className='text-xl sm:text-2xl animate-pulse'/>
                        <span>Service Details&nbsp;</span>
                    </button>
                </header>
                <div className='grid grid-cols-3 gap-3 pb-2 h-full items-center'>
                    {[...airconDeals].filter(d => d.serviceType === "compressorCleaning").slice(0,3).map((listing, i) =>
                        <button type='button' key={i} className='rounded-2xl shadow-lg border border-gray-100 hover:scale-102 hover:-translate-y-1 transition-all bg-white w-full overflow-hidden' 
                            onClick={() => quickBook(listing.unit, listing.serviceType)}
                            role="link"
                            aria-label={`Book ${listing.unit} unit compressor cleaning service`} 
                        >                                    
                            <div className="p-3 text-center">
                                <div className="bg-linear-to-r from-indigo-500 to-purple-500 text-white text-sm sm:text-lg font-bold px-2 py-1 rounded-full shadow whitespace-nowrap inline-block">
                                    ${listing.cost}
                                </div>
                                <div className="mt-2 space-y-1">
                                <h4 className="font-semibold text-gray-800 text-sm">{listing.unit} Compressor</h4>
                                {listing.originalCost > 0 && (
                                    <div className="text-xs text-gray-400 line-through">${listing.originalCost}</div>
                                )}
                            </div>
                                </div>
                        </button>
                    )}
                </div>
            </section>
        }
        {(selectedService === "compressor" || selectedService === "all") &&
            <section className='space-y-4 py-2'>
                <header className='flex items-center space-x-2'>
                    <h3 className='font-bold sm:text-lg'>                
                        Compressor Chemical Wash
                    </h3>
                    <button type="button" className="text-orange-600 text-sm flex items-center gap-1 hover:underline" onClick={() => showJobScope("compressorCleaning")} aria-label="View service details">
                        <MdKeyboardDoubleArrowRight className='text-xl sm:text-2xl animate-pulse'/>
                        <span>Details&nbsp;</span>
                    </button>
                </header>
                <div className='grid grid-cols-3 gap-3 pb-2 h-full items-center'>
                    {[...airconDeals].filter(d => d.serviceType === "compressorChemicalCleaning").slice(0,3).map((listing, i) =>
                        <button type='button' key={i} className='rounded-2xl shadow-lg border border-gray-100 hover:scale-102 hover:-translate-y-1 transition-all bg-white w-full overflow-hidden' 
                            onClick={() => quickBook(listing.unit, listing.serviceType)}
                            role="link"
                            aria-label={`Book ${listing.unit} unit compressor cleaning service`} 
                        >                                    
                            <div className="p-3 text-center">
                                <div className="bg-linear-to-r from-indigo-500 to-purple-500 text-white text-sm sm:text-lg font-bold px-2 py-1 rounded-full shadow whitespace-nowrap inline-block">
                                    ${listing.cost}
                                </div>
                                <div className="mt-2 space-y-1">
                                <h4 className="font-semibold text-gray-800 text-sm">{listing.unit} Compressor</h4>
                                {listing.originalCost > 0 && (
                                    <div className="text-xs text-gray-400 line-through">${listing.originalCost}</div>
                                )}
                            </div>
                                </div>
                        </button>
                    )}
                </div>
            </section>
        }
    </>
  )
}